import { BsAlertCircle } from 'react-icons/bs';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 16px;
  border-radius: 12px;
  background-color: ${ColorPalette.HEX.Cultured4};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;

export const Title = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43;
  color: ${ColorPalette.HEX.RedRYB2};
  margin-bottom: 8px;
`;

export const Content = styled.div`
  font-size: 12px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.RedRYB};
`;

export const AlertIcon = styled(BsAlertCircle)`
  min-height: 16px;
  min-width: 16px;
  color: ${ColorPalette.HEX.RedRYB} !important;
`;
